// components
import { Typography } from '@centria-ui-atoms/typography'

// prime component
import { SelectButton as PrSelectButton } from 'primereact/selectbutton'

// styles
import classes from './styles.module.scss'

// types
import type { SelectButtonProps as PrSelectButtonProps } from 'primereact/selectbutton'
import type { FC } from 'react'

export interface SelectButtonProps extends PrSelectButtonProps {
  label?: string
  variant?: 'outline' | 'filled'
}

export const SelectButton: FC<SelectButtonProps> = ({
  label,
  children,
  className = '',
  variant = 'outline',
  color = 'secondary',
  ...props
}) => (
  <div className='w-100'>
    {label && (
      <Typography
        Tag='label'
        fontSize='small'
        className='mb-1'
        htmlFor={props.id}>
        {label}
      </Typography>
    )}
    <PrSelectButton
      {...props}
      className={`${classes[`select_${color}`]} ${
        classes[`select_${variant}`]
      } ${classes.select} ${className}`}
    />
  </div>
)
